import { render, staticRenderFns } from "./ActionGeneric.vue?vue&type=template&id=d2b7577c&"
import script from "./ActionGeneric.vue?vue&type=script&lang=js&"
export * from "./ActionGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports